import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch {
      toast.error("Erreur, réessayez plus tard");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <div className="mb-6">
          <Link to="/login" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary" data-testid="back-to-login">
            <ArrowLeft className="w-4 h-4" /> Retour à la connexion
          </Link>
        </div>

        <div className="bg-card/80 border border-white/10 rounded-2xl p-8">
          <div className="text-center mb-6">
            <div className="w-14 h-14 mx-auto rounded-2xl bg-primary/10 border border-primary/30 flex items-center justify-center mb-3">
              {sent ? <CheckCircle2 className="w-7 h-7 text-primary" /> : <Mail className="w-7 h-7 text-primary" />}
            </div>
            <div className="text-[10px] uppercase tracking-[4px] text-primary mb-1">TRADEX AI</div>
            <h1 className="text-2xl font-bold">
              {sent ? 'Vérifiez votre email' : 'Mot de passe oublié'}
            </h1>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
              {sent
                ? 'Si un compte est associé à cet email, un lien de réinitialisation valable 30 minutes vient de vous être envoyé.'
                : 'Saisissez votre email — nous vous enverrons un lien de réinitialisation.'}
            </p>
          </div>

          {!sent && (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground z-10" />
                  <Input
                    id="email"
                    type="email"
                    autoComplete="email"
                    required
                    data-testid="forgot-email-input"
                    className="pl-10 bg-secondary/50 border-white/10"
                    placeholder="vous@exemple.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <Button type="submit" className="w-full py-6 font-mono uppercase tracking-wider" disabled={loading} data-testid="forgot-submit">
                {loading ? <Loader2 className="w-5 h-5 mr-2 animate-spin" /> : null}
                {loading ? 'Envoi…' : 'Envoyer le lien'}
              </Button>
            </form>
          )}

          {sent && (
            <div className="text-center">
              <p className="text-xs text-muted-foreground mb-4">
                Pensez à vérifier vos spams si vous ne recevez rien dans 2 minutes.
              </p>
              <Link to="/login">
                <Button variant="outline" className="w-full">Retour à la connexion</Button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
